import { render, staticRenderFns } from "./detailEdit.vue?vue&type=template&id=b8714b40&scoped=true&"
import script from "./detailEdit.vue?vue&type=script&lang=js&"
export * from "./detailEdit.vue?vue&type=script&lang=js&"
import style0 from "./detailEdit.vue?vue&type=style&index=0&id=b8714b40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8714b40",
  null
  
)

export default component.exports